<section *ngIf="atLeastOneElementHasContent(data)" class="mb-3 p-1">
    <h2 *ngIf="data.titleKey" [innerHTML]="data.titleKey | fromDictionary" class="h4 mb-3 ps-1"></h2>
    <dl class="medium row me-0 ms-0 ps-3 pe-3">
        <ng-container *ngFor="let element of data.elements; index as index">
            <dt
                *ngIf="hasContent(element)"
                [class.border-top]="data.titleKey || index !== 0"
                [innerHTML]="element.key | fromDictionary"
                class="col-md-4 fw-light border-grey p-1"
            ></dt>
            <dd
                *ngIf="!isAddress(element) && hasContent(element)"
                [class.border-top]="data.titleKey || index !== 0"
                [id]="buildId(element)"
                [innerHTML]="cleanValue(element)"
                class="col-md-8 fw-light border-grey p-1"
            ></dd>
            <dd
                *ngIf="isAddress(element) && hasContent(element)"
                [class.border-top]="data.titleKey || index !== 0"
                [id]="buildId(element)"
                class="col-md-8 fw-light  border-grey p-1"
            >
                <foehn-display-address
                    [address]="element.value"
                ></foehn-display-address>
            </dd>
        </ng-container>
        <ng-container *ngIf="hasActionsAvailable()">
            <dt
                class="col-md-4 fw-light border-top border-grey p-1"
            >
                {{ actionsText }}
            </dt>
            <dd
                class="col-md-8 fw-light border-top border-grey p-1"
                id="actions"
            >
                <span (click)="doEdit()" *ngIf="canEdit" class="recap-badge bg-light"
                      style="border-radius: .25rem; float: left;">
                    <foehn-icon-edit style="margin-right: 3px;"></foehn-icon-edit>
                    {{ editText }}
                </span>
                <span (click)="doDelete()" *ngIf="canDelete" class="recap-badge bg-danger"
                      style="border-radius: .25rem; float: right; margin-right: 10%">
                    <foehn-icon-trash-alt style="margin-right: 3px;"></foehn-icon-trash-alt>
                    {{ deleteText }}
                </span>
            </dd>
        </ng-container>
    </dl>
</section>
